import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Col, Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import OrganizedUnitSaleOperationModalPage from '../../../containers/masters/OrganizedUnitSaleOperation/OrganizedUnitSaleOperationModalPage'
import InputSelect from '../../commons/form/InputSelect'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class OrganizedUnitSaleOperationMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        organizedUnitId: null,
        saleTypeId: null,
        operationTypeId: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchOrganizedUnitsAll()
    this.props.actions.fetchSaleTypeAll()
    this.props.actions.fetchOperationTypeAll()
    this.props.actions.fetchOrganizedUnitSaleOperationList()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchOrganizedUnitSaleOperationList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchOrganizedUnitSaleOperationList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleOrganizedUnitsByOperationTypesChange (organizedUnitId) {
    if (this.state.filter.organizedUnitId !== organizedUnitId) {
      this.setState({ filter: { ...this.state.filter, organizedUnitId } })
    }
  }

  handleSaleTypeOperationChange (saleTypeId) {
    if (this.state.filter.saleTypeId !== saleTypeId) {
      this.setState({ filter: { ...this.state.filter, saleTypeId } })
    }
  }

  handleoperationTypeAllComboChange (operationTypeId) {
    if (this.state.filter.operationTypeId !== operationTypeId) {
      this.setState({ filter: { ...this.state.filter, operationTypeId } })
    }
  }

  search () {
    this.props.actions.fetchOrganizedUnitSaleOperationList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  resetFilters () {
    this.setState({
      filter: {
        organizedUnitId: null,
        saleTypeId: null,
        operationTypeId: null
      }
    }, () => { this.search() })
  }

  render () {
    const {
      t, organizedUnitSaleOperationList, pagesCount, organizedUnitSaleOperationsCount, filter,
      combos: { organizedUnitsAllCombo, saleTypeAllCombo, operationTypeAllCombo },
      filter: { page },
      actions: { openOrganizedUnitSaleOperationModal, fetchOrganizedUnitSaleOperationList, deleteOrganizedUnitSaleOperation }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'organizedUnitSaleOperationMasterPage' })
    const tKey = 'MASTERS.OPERATION_TYPE_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const hasFilters = (this.state.filter.operationTypeId || this.state.filter.organizedUnitId || this.state.filter.saleTypeId)
    return (
      <div id="organizedUnitSaleOperationMaster" className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openOrganizedUnitSaleOperationModal()}>
              <i className='iDocIcon-add-plus'></i> {t(`${tKey}ADD`)} {t(`${secMapMasters.title}`)}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.organizedUnitId"
                controlLabel={t(`${tKey}NAME_OU`)}
                placeholder={t(`${tKey}NAME_OU`)}
                valueKey="id"
                labelKey="value"
                options={organizedUnitsAllCombo}
                onInputChange={(value) => this.handleOrganizedUnitsByOperationTypesChange(value)}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.saleTypeId"
                controlLabel={t(`${tKey}NAME_SALE_TYPE`)}
                placeholder={t(`${tKey}NAME_SALE_TYPE`)}
                valueKey="id"
                labelKey="value"
                options={saleTypeAllCombo}
                onInputChange={(value) => this.handleSaleTypeOperationChange(value)}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.operationTypeId"
                controlLabel={t(`${tKey}NAME_TYPE_OPERATION`)}
                placeholder={t(`${tKey}NAME_TYPE_OPERATION`)}
                valueKey="id"
                labelKey="value"
                options={operationTypeAllCombo}
                onInputChange={(value) => this.handleoperationTypeAllComboChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.search()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? '' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}>
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              <Table className="editable-table" hover responsive>
                <thead>
                  <tr>
                    <th onClick={() => { this.changeOrder('organizedUnitId') }}>
                      {t(`${tKey}NAME_OU`)}
                      <i className={this.getSortIcon('organizedUnitId')} />
                    </th>
                    <th onClick={() => { this.changeOrder('saleTypeId') }}>
                      {t(`${tKey}NAME_SALE_TYPE`)}
                      <i className={this.getSortIcon('saleTypeId')} />
                    </th>
                    <th onClick={() => { this.changeOrder('operationTypeId') }}>
                      {t(`${tKey}NAME_TYPE_OPERATION`)}
                      <i className={this.getSortIcon('operationTypeId')} />
                    </th>
                    <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                  </tr>
                </thead>
                <tbody>
                  {organizedUnitSaleOperationList && organizedUnitSaleOperationList.map((operationType, idx) => {
                    return (
                      <tr key={idx} className={operationType.isDeleted ? 'is-deleted' : ''}>
                        <td>{organizedUnitsAllCombo && organizedUnitsAllCombo.find(x => x.id === operationType?.organizedUnitId) && organizedUnitsAllCombo.find(x => x.id === operationType?.organizedUnitId).value}</td>
                        <td>{saleTypeAllCombo && saleTypeAllCombo.find(x => x.id === operationType?.saleTypeId) && saleTypeAllCombo.find(x => x.id === operationType?.saleTypeId).value}</td>
                        <td>{operationTypeAllCombo && operationTypeAllCombo.find(x => x.id === operationType?.operationTypeId) && operationTypeAllCombo.find(x => x.id === operationType?.operationTypeId).value}</td>
                        <td className='actions'>
                          {!operationType.isDeleted && (
                            <div>
                              <OverlayTrigger placement="left" overlay={editTooltip}>
                                <a className='_Btn accept stk o-icn ' onClick={() => openOrganizedUnitSaleOperationModal(operationType)}>
                                  <i className="iDocIcon-edit" />
                                </a>
                              </OverlayTrigger>
                              <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                <a className='_Btn cancel stk o-icn ' onClick={() => deleteOrganizedUnitSaleOperation(operationType.organizedUnitSaleOperationId)}>
                                  <i className="iDocIcon-delete-forever" />
                                </a>
                              </OverlayTrigger>
                            </div>
                          )}
                        </td>
                      </tr>
                    )
                  })}

                </tbody>
              </Table>
              {(organizedUnitSaleOperationList === null || organizedUnitSaleOperationList === undefined || organizedUnitSaleOperationList.length === 0) &&
                <p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-use¡rs-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={organizedUnitSaleOperationsCount}
                    onSelectAction={(value) => fetchOrganizedUnitSaleOperationList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>

        <Col sm={12} className="col-row  section-users-body">

        </Col>
        <OrganizedUnitSaleOperationModalPage/>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listDocumentType'
})(OrganizedUnitSaleOperationMaster)
